import serverReducer from "common/server/ducks";
import ProjectRedirect from "common/server/containers/project_redirect";

export { ProjectRedirect };
export default serverReducer;
